import { module } from 'angular';

import downloadService from './download.service';

export default module('app')
	.factory('FileDownloadService', downloadService)
	.name;
